<template>
    <div class="guidanceWrapper">
        <div class="columns guidanceRow">
            <div class="guidanceItem">
                <img class="guidanceImage" src="@/assets/images/applications/Example_Document_Scan_CORRECT.jpg">
                <p class="guidanceNote">Take clear photos of documents like this</p>
            </div>
            <div class="guidanceItem">
                <img class="guidanceImage" src="@/assets/images/applications/Example_ID_Badge_Scan_CORRECT.jpg">
                <p class="guidanceNote">Take clear photos of ID cards like this</p>
            </div>
        </div>

        <div class="columns guidanceRow">
            <div class="guidanceItem">
                <img class="guidanceImage" src="@/assets/images/applications/Example_ID_Blurred_INCORRECT.jpg">
                <p class="guidanceNote">Too blurry - make sure image is in focus</p>
            </div>
            <div class="guidanceItem">
                <img class="guidanceImage" src="@/assets/images/applications/Example_ID_Light_Glare_INCORRECT.jpg">
                <p class="guidanceNote">Too much glare - look for better lighting</p>
            </div>
        </div>

        <div class="columns guidanceRow">
            <div class="guidanceItem">
                <img class="guidanceImage" src="@/assets/images/applications/Example_ID_Rotated-Small_INCORRECT.jpg">
                <p class="guidanceNote">Not centered - frame the image properly</p>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../assets/variables.scss";

.guidanceWrapper {
    width: 100%;
    display: flex; flex-direction: column;
    align-items: center;
    padding-top: 1.5rem;
}

.guidanceRow {
    gap: 2rem;
}

.guidanceItem {
    max-width: 20rem;
    padding-bottom: 2rem;
}

.guidanceNote {
    font-weight: bold;
}
</style>